if (!customElements.get("landing-media")) {
  class LandingMedia extends HTMLElement {
    constructor() {
      super();
    }

    onSlideChange() {
      const activeReel = this.currentlyPlayingReel;
      if (activeReel) {
        this.toggleVideoState(activeReel);
      }

      const activeSlide = this.querySelector('.swiper-slide-active');
      const activeSlideReel = activeSlide.querySelector('video');
      if (!activeSlideReel) {
        return;
      }

      this.toggleVideoInSlide(activeSlide);
    }

    getSlideVideo(slide) {
      return slide.querySelector('video');
    }

    get currentlyPlayingReel() {
      return this.querySelector('video.is-playing');
    }

    toggleVideoInSlide(activeSlide) {
      const video = this.getSlideVideo(activeSlide);
      this.toggleVideoState(video);
    }

    toggleVideoState(video) {
      video.classList.toggle('is-playing', video.paused);
      if (video.paused) {
        video.play();
        return;
      }

      video.pause();
    }

    connectedCallback() {
      this.swiper = new Swiper(this.querySelector(".swiper"), {
        spaceBetween: 7,
        initialSlide: this.hasAttribute("js-reverse")
          ? this.querySelectorAll(".swiper-slide").length - 1
          : 0,
        breakpoints: {
          990: {
            spaceBetween: 5,
          },
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        on: {
          init: () => {
            this.onSlideChange();
          },
          slideChangeTransitionEnd: swiper => {
            this.onSlideChange();
          }
        }
      });
    }
  }

  customElements.define("landing-media", LandingMedia);
}
